import { PaymentStatusType } from 'src/assets/enums/payment';

export const payment_status = [
  {
    title: 'All',
    value: '',
  },
  {
    title: 'Paid',
    value: PaymentStatusType.PAID,
  },
  {
    title: 'Partially paid',
    value: PaymentStatusType.PARTIALLY_PAID,
  },
  {
    title: 'Not paid',
    value: PaymentStatusType.NOT_PAID,
  },
];

export const PaymentStatusButton = (status: string, className?: string) => {
  let color = '';
  let bg = '';
  let text = '';
  switch (status) {
    case PaymentStatusType.PAID:
      color = '#0BC988';
      text = payment_status[1].title;
      bg = '#CEF4E7';
      break;
    case PaymentStatusType.NOT_PAID:
      color = '#E22B41';
      text = payment_status[3].title;
      bg = '#F9D5D9';
      break;
    case PaymentStatusType.PARTIALLY_PAID:
      color = '#FEC02D';
      text = payment_status[2].title;
      bg = '#FFF2D5';
      break;
    default:
      break;
  }
  return (
    <div
      style={{
        backgroundColor: bg,
      }}
      className={`px-1 rounded-[5px] text-[${color}] justify-center flex text-xs items-center ${className}`}
    >
      {text}
    </div>
  );
};
